import { comboProduct } from 'app/core/models/slice/combo/comboProduct'

/**
 * 콤보리스트
 */
export interface comboProductList {
    /** comboProductList[]
     * @type {comboProduct[]}
     */

    comboProductList: comboProduct[]
}

/**
 *
 */
export const initialState: comboProductList = {
    comboProductList: [
        {
            rltdPdlnCd: '',
            rltdPdgrCd: '',
            rltdPdtmCd: '',
            rltdPdcd: '',
            rltdPdm: '',
            nofcRlncPgrsScd02: '',
            nofcCmbTcd: '',
            nofcCmbPgrsYn: '',
            nfchPrcfGrpCd: '',
            allPdcd: '',
        },
    ],
}
